import {
  RuleParamSchema,
  ValidationMessageTemplate,
  ValidationRuleFunction,
  ValidationRuleSchema,
} from "vee-validate/dist/types/types"

import { maxLinesValidator } from "./maxLinesValidator"
import { customMessage } from "./validatorUtil"

export class MaxLinesRuleSchema implements ValidationRuleSchema {
  validate: ValidationRuleFunction = (value, params) => {
    return maxLinesValidator(value, params)
  }
  params: RuleParamSchema[] = ["max"]
  message: ValidationMessageTemplate = (field: string, params?: Record<string, any>) => {
    return customMessage(field, params, ["max"])
  }
}
